import type { BaseUrl, ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type {
	OtherProjectCalendarRestResponse,
	OtherProjectWorkingHours,
	OtherProjectWorkingHoursRestResponse,
	OtherProjectCalendar,
	OtherProjectCalendars,
	OtherProjectCalendarsRestResponse,
} from '../calendars/types';
import {
	mapHolidaysRestResponseToHolidays,
	mapTimezoneToSelectOption,
	mapTimezoneToSelectOptions,
	mapWorkingTimesRestResponseToWorkingTimes,
} from '../calendars/utils';
import type { OtherProjectCalendarsModalState } from './types';

export const getUrl = (baseUrl: BaseUrl, projectKey: ProjectKey): string =>
	`${baseUrl}/rest/workinghours/1/internal/dialog/${projectKey}/shared`;

const transformCalendarResponseForOtherProjects = ({
	workingTimes,
	holidays,
	...calendarData
}: OtherProjectCalendarRestResponse): OtherProjectCalendar => ({
	...calendarData,
	workingTimes: mapWorkingTimesRestResponseToWorkingTimes(workingTimes),
	holidays: mapHolidaysRestResponseToHolidays(holidays),
});

const transformCalendarsResponseForOtherProjects = (
	request: OtherProjectCalendarsRestResponse,
): OtherProjectCalendars => request.map(transformCalendarResponseForOtherProjects);

export const transformResponse = ({
	calendars,
	allTimezones,
	defaultTimezone,
	...rest
}: OtherProjectWorkingHoursRestResponse): OtherProjectWorkingHours => ({
	allTimezones: mapTimezoneToSelectOptions(allTimezones),
	defaultTimezone: mapTimezoneToSelectOption(defaultTimezone),
	calendars: transformCalendarsResponseForOtherProjects(calendars),
	...rest,
});

export const getOtherProjectCalendarsStateWithCanCreate = (
	otherCalendarsState: OtherProjectCalendarsModalState,
	// Adding a new calendar/copying from other serviceDesk projects depends on this variable
	canCreate: boolean,
): OtherProjectCalendarsModalState => ({
	...otherCalendarsState,
	permissionsWithTimezoneInfo: {
		// @ts-expect-error - TS2322 - Type 'TimeZones | undefined' is not assignable to type 'TimeZones'.
		allTimezones: otherCalendarsState.permissionsWithTimezoneInfo?.allTimezones,
		// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
		dateFormat: otherCalendarsState.permissionsWithTimezoneInfo?.dateFormat,
		// @ts-expect-error - TS2322 - Type 'TimeZone | undefined' is not assignable to type 'TimeZone'.
		defaultTimezone: otherCalendarsState.permissionsWithTimezoneInfo?.defaultTimezone,
		canCreate,
	},
});
